import React from 'react';
import { Route } from 'react-router';
import VerifyEmailContainer from 'split-chunk-loader?lazy!../VerifyEmail/VerifyEmailContainer';
import { lazify } from '../Common/Helper';

const VerifyEmailRoute = (
  <Route
    label="Email Verification"
    helmet={{
      title: "Email Verification"
    }}
    path="verify/:hash"
    component={lazify(VerifyEmailContainer)}
  />
);

export default VerifyEmailRoute;



// WEBPACK FOOTER //
// ./src/Routes/VerifyEmailRoute.js